module.exports = __webpack_public_path__ + "img/derp.9e42f19b.jpg";